import React, { useState } from 'react';
import { APIUrl } from '../../common/apiClient';
import { toast } from 'react-toastify';


export const ForgotPassword: React.FC = () => {
  const [userName, setUserName] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!userName) {
      toast.error('Please enter your username / email');
      return;
    }

    setSubmitting(true);
    try {
      const response = await fetch(APIUrl + '/users/forgot_password_request', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userName }),
      });
      const data = await response.json();
      if (response.ok) {
        toast.info(data.status || 'If the user exists, password reset instructions have been sent');
        window.location.replace('/login');
      } else {
        toast.error(data.status || 'Failed to initiate password reset');
      }
    } catch (e) {
      console.error('Failed to initiate forgot password', e);
      toast.error('An error occurred while initiating password reset');
    } finally {
      setSubmitting(false);
    }
  };

  const goToLogin = () => {
  window.location.replace('/login');

};

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #247695 0%, #0b3556 100%)',
        padding: '16px',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 420,
          backgroundColor: '#ffffff',
          borderRadius: 8,
          boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
          padding: '24px 24px 32px',
          boxSizing: 'border-box',
        }}
      >
        <h2 style={{ marginTop: 0, marginBottom: 8, textAlign: 'center', color: '#123b63' }}>
          Forgot Password
        </h2>
        <p style={{ marginTop: 0, marginBottom: 24, fontSize: 14, color: '#555', textAlign: 'center' }}>
          Enter your username or email address and we will send you a reset link.
        </p>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', marginBottom: 4, fontSize: 13, fontWeight: 500 }}>
              Username / Email
            </label>
            <input
              type="text"
              value={userName}
              onChange={e => setUserName(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                boxSizing: 'border-box',
                borderRadius: 4,
                border: '1px solid #ccd4dd',
                fontSize: 14,
              }}
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            style={{
              width: '100%',
              padding: '10px 12px',
              borderRadius: 4,
              border: 'none',
              backgroundColor: submitting ? '#7ba5c3' : '#247695',
              color: '#fff',
              fontSize: 15,
              fontWeight: 600,
              cursor: submitting ? 'default' : 'pointer',
              transition: 'background-color 0.2s ease',
              marginBottom: 12,
            }}
          >
            {submitting ? 'Sending...' : 'Send reset link'}
          </button>
        </form>
        <button
          type="button"
          onClick={goToLogin}
          style={{
            width: '100%',
            padding: '8px 12px',
            borderRadius: 4,
            border: 'none',
            backgroundColor: '#e0e7ef',
            color: '#123b63',
            fontSize: 14,
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Back to login
        </button>
      </div>
    </div>
  );
};
